export interface MedicationRow {
  id: number;
  clinicalRowId: string;
  orderDate: string;
  medication: string;
  dose: string;
  route: string;
  frequency: string;
  purposeDx: string;
  status: string;
  dcdDate: string;
  isFromPreviousAssessment: boolean;
}

/** Existing rows without IDs must retain the server's historical identity matching. */
export function serializeMedicationRows(rows: MedicationRow[]): Record<string, unknown>[] {
  return rows.map((row) => ({
    ...(row.clinicalRowId ? { clinicalRowId: row.clinicalRowId } : {}),
    orderDate: row.orderDate || '',
    medication: row.medication,
    dose: row.dose,
    route: row.route,
    frequency: row.frequency,
    purposeDx: row.purposeDx,
    status: row.status,
    dcdDate: row.status === 'Discontinued' ? row.dcdDate : '',
    isFromPreviousAssessment: row.isFromPreviousAssessment,
  }));
}

/** Draft saves may omit diagnoses, but every started row must be complete. */
export function otherDiagnosisValidationMessage(
  rows: Array<{ icdCode: string; description: string; date: string }>,
  required: boolean,
): string | undefined {
  const started = rows.filter(row => row.icdCode.trim() || row.description.trim() || row.date);
  if (started.some(row => !row.icdCode.trim() || !row.description.trim())) {
    return 'Each other diagnosis requires ICD code and description.';
  }
  if (required && !started.length) {
    return 'At least one other pertinent diagnosis with ICD code and description is required.';
  }
  return undefined;
}
